import(/* webpackMode: "eager" */ "/vercel/path0/sun/src/app/about/page.tsx");
